module.exports = __webpack_public_path__ + "static/m-jung-a6a4c42b15de028f5217cc286647c989.png";